import { Link } from 'react-router-dom';
import { useSiteSettings } from '../hooks/useSiteSettings';

export const Logo = ({ className = '', variant = 'full', isLight = false }) => {
  const { settings } = useSiteSettings();

  if (variant === 'icon') {
    return (
      <Link to="/" className={`block ${className}`} data-testid="logo-icon">
        {settings.logo_url ? (
          <img
            src={settings.logo_url}
            alt="Le Bontà del Vesuvio"
            className="h-10 w-auto object-contain"
          />
        ) : (
          <span className={`font-heading font-bold text-lg italic ${isLight ? 'text-white' : 'text-primary-dark'}`}>
            BdV
          </span>
        )}
      </Link>
    );
  }

  return (
    <Link to="/" className={`flex items-center gap-3 ${className}`} data-testid="logo-link">
      {settings.logo_url ? (
        <img
          src={settings.logo_url}
          alt="Le Bontà del Vesuvio"
          className="h-14 md:h-16 w-auto object-contain"
        />
      ) : (
        <div className="flex flex-col">
          <span className={`text-[10px] uppercase tracking-[0.2em] font-body font-semibold leading-tight ${isLight ? 'text-white' : 'text-primary'}`}>
            Azienda Agricola
          </span>
          <span className={`font-heading text-xl md:text-2xl font-bold leading-tight italic ${isLight ? 'text-white' : 'text-primary-dark'}`}>
            le Bontà del Vesuvio
          </span>
        </div>
      )}
    </Link>
  );
};

// Keep for backward compat
export const LogoImage = ({ className = '' }) => {
  const { settings } = useSiteSettings();
  return (
    <Link to="/" className={`block ${className}`} data-testid="logo-image-link">
      <img
        src={settings.logo_url}
        alt="Azienda Agricola Le Bontà del Vesuvio"
        className="h-16 md:h-20 w-auto object-contain"
      />
    </Link>
  );
};

